import { DateTime } from 'luxon';
import { fromJsonArrayWith } from 'src/core/utils';
import { Address, BasicAddress } from '../basic-types/Address';
import SelectedProduct from '../cart/request/SelectedProduct';

export class MyOffer {
    public readonly id: number;
    public readonly publicId: string;
    public readonly externalOrderId: string;
    public readonly customerId: number;
    public readonly originUserId: number;
    public readonly orderProductList: SelectedProduct[];
    public readonly gross: boolean;
    public readonly totalAmount: number;
    public readonly currencyIso: string;
    public readonly mandant: string;
    public readonly paymentMethodIdentifier: string;
    public readonly invoiceState: boolean;
    public readonly billingAddress: Address | BasicAddress;
    public readonly deliveryAddress: Address | BasicAddress;
    public readonly preparedOn: DateTime;
    public readonly validUntil: DateTime;
    public readonly additionalProperties: Record<string, string>;

    constructor(json: any) {
        this.id = json.id;
        this.publicId = json.publicId;
        this.externalOrderId = json.externalOrderId;
        this.customerId = json.customerId;
        this.originUserId = json.originUserId;
        this.orderProductList = fromJsonArrayWith(SelectedProduct.fromJson, json.orderProductList);
        this.gross = json.gross;
        this.totalAmount = json.totalAmount;
        this.currencyIso = json.currencyIso4217 || json.currencyIso;
        this.mandant = json.mandant;
        this.paymentMethodIdentifier = json.paymentMethodIdentifier;
        this.invoiceState = json.invoiceState;

        this.billingAddress = json.billingAddress.id
            ? new Address(json.billingAddress)
            : new BasicAddress(json.billingAddress);
        this.deliveryAddress = json.deliveryAddress.id
            ? new Address(json.deliveryAddress)
            : new BasicAddress(json.deliveryAddress);

        this.preparedOn = DateTime.fromISO(json.preparedOn);
        this.validUntil = DateTime.fromISO(json.validUntil);
        this.additionalProperties = json.additionalProperties ?? {};
    }
}
